import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Preact from 'preact';
import * as Button from './A_Button';
import { isSmallScreen } from './domain/theme/breakpoints';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (props) {
    var t = useTranslations().t;
    var theme = useTheme();
    var isSmall = isSmallScreen(theme);
    return (Preact.h(Box, { sx: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: '#F5F5F5',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: theme.zIndex.modal,
        } },
        Preact.h(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '10px',
                background: 'white',
                width: '351px',
            } },
            Preact.h(Box, { sx: {
                    height: '64px',
                    width: '100%',
                    padding: '16px',
                    boxSizing: 'border-box',
                    borderBottom: '1px solid rgba(0, 0, 0, .15)',
                } },
                Preact.h(Typography, { textAlign: "center", variant: "h6" }, t('error.render.primary'))),
            Preact.h(Typography, { textAlign: "center", variant: "body3", color: "secondary", padding: "24px" }, t('error.render.secondary')),
            isSmall && props.openConfigurePanel && (Preact.h(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingBottom: '16px',
                } },
                Preact.h(Button.Component, { variant: "contained", size: "medium", onClick: props.openConfigurePanel }, t('error.render.action')))))));
};
Component.displayName = 'Modal';
